
import SAJM_GLOBALS from "../constants";
import GlobalUser from "../models/User";

export class ContactController{
    /*
    
    Get List of all contacts

    */

    async getContacts() {

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "getContacts",
                                        apiKey: apiKey,
                                        apiToken: token,
                                         })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("ContactController.getContacts:"+error);
        }
    }

    /*
    
    Create new contact

    */

    async createContact(name, firstname, mail, phone, adresse1, adresse2, postcode, city, comment){
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();
        
        try {
            
            const apiFunctionParams =  "{\"name\": \""+name+"\", "+
                                        "\"firstname\": \""+firstname+"\", "+
                                        "\"mail\": \""+mail+"\", "+
                                        "\"phone\": \""+phone+"\", "+
                                        "\"adresse1\": \""+adresse1+"\", "+
                                        "\"adresse2\": \""+adresse2+"\", "+
                                        "\"postcode\": \""+postcode+"\", "+
                                        "\"city\": \""+city+"\", "+
                                        "\"comment\": \""+comment+"\" "+
            "}";


            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "createContact",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("ContactController.createContact:"+error);
        }
    }

    /*
    
    Update contact

    */

    async updateContact(id, name, firstname, mail, phone, adresse1, adresse2, postcode, city, comment){
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();
        
        try {
            comment = comment.replaceAll('\n', '\\n'); //manage \n
            const apiFunctionParams =  "{\"id\": \""+id+"\", "+
                                        "\"name\": \""+name+"\", "+
                                        "\"firstname\": \""+firstname+"\", "+
                                        "\"mail\": \""+mail+"\", "+
                                        "\"phone\": \""+phone+"\", "+
                                        "\"adresse1\": \""+adresse1+"\", "+
                                        "\"adresse2\": \""+adresse2+"\", "+
                                        "\"postcode\": \""+postcode+"\", "+
                                        "\"city\": \""+city+"\", "+
                                        "\"comment\": \""+comment+"\" "+
            "}";


            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "updateContact",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            
            let url = SAJM_GLOBALS.API_HOST+"/";
                       
            const response = await fetch(url, requestOptions);
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("ContactController.updateContact:"+error);
        }
    }

    /*
    
    get Contact by ID

    */

    async getContactByID(id){
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();
        
        try {
            
            const apiFunctionParams =  "{\"id\": \""+id+"\"}";

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "getContactByID",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("ContactController.getContactByID:"+error);
        }
    }

    /*
    
    delete Contact

    */

    async deleteContact(id){
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();
        
        try {
            
            const apiFunctionParams =  "{\"id\": \""+id+"\"}";

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "deleteContact",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("ContactController.deleteContact:"+error);
        }
    }

    /*
    
    search Contact by Mail

    */

    async getContactByMail(mail){
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();
        
        try {
            
            const apiFunctionParams =  "{\"mail\": \""+mail+"\"}";

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "getContactByMail",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("ContactController.getContactByMail:"+error);
        }
    }

}